import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const links = [{
    name: 'HUB',
    path: '/'
  }, {
    name: 'ABOUT',
    path: '/about'
  }, {
    name: 'COACHING',
    path: '/coaching'
  }, {
    name: 'CONTACT',
    path: '/contact'
  }];
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);
  return <>
      <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-dark-primary/95 backdrop-blur-md border-b border-dark-border py-3' : 'bg-transparent py-5'}`} data-id="element-28">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-29">
          <Link to="/" className="text-2xl font-heading tracking-widest text-white hover:text-accent-blue transition-colors" data-id="element-30">
            ALEKS SZULC
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-31">
            {links.map(link => {
            const isActive = location.pathname === link.path;
            return <Link key={link.name} to={link.path} className={`text-sm font-heading tracking-wider transition-colors relative ${isActive ? 'text-accent-blue' : 'text-gray-300 hover:text-white'}`} data-id="element-32">
                  {link.name}
                  {isActive && <motion.div layoutId="nav-indicator" className="absolute -bottom-1 left-0 w-full h-0.5 bg-accent-blue" data-id="element-33" />}
                </Link>;
          })}
          </nav>

          {/* Mobile Toggle */}
          <button className="md:hidden text-white p-2" onClick={() => setIsOpen(true)} aria-label="Open menu" data-id="element-34">
            <Menu className="w-6 h-6" data-id="element-35" />
          </button>
        </div>
      </header>

      {/* Mobile Drawer */}
      <AnimatePresence data-id="element-36">
        {isOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsOpen(false)} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 md:hidden" data-id="element-37" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed top-0 right-0 h-full w-64 bg-dark-elevated border-l border-dark-border z-50 flex flex-col p-6 md:hidden" data-id="element-38">
              <div className="flex justify-end mb-8" data-id="element-39">
                <button onClick={() => setIsOpen(false)} className="text-gray-400 hover:text-white p-2" aria-label="Close menu" data-id="element-40">
                  <X className="w-6 h-6" data-id="element-41" />
                </button>
              </div>
              <nav className="flex flex-col gap-6" data-id="element-42">
                {links.map(link => {
              const isActive = location.pathname === link.path;
              return <Link key={link.name} to={link.path} className={`text-xl font-heading tracking-wider transition-colors ${isActive ? 'text-accent-blue' : 'text-gray-300 hover:text-white'}`} data-id="element-43">
                      {link.name}
                    </Link>;
            })}
              </nav>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}